import {ComponentType} from 'react'
import {SvgIconProps} from '@material-ui/core/SvgIcon'
import AccountBalanceWalletOutlined from '@material-ui/icons/AccountBalanceWalletOutlined'
import LayersOutlined from '@material-ui/icons/LayersOutlined'
import PeopleOutlined from '@material-ui/icons/PeopleOutlined'
import {Trans} from 'react-i18next'
import messages from '../../../assets/messages'
import {getFormattedAmount} from '../../../common/utils/general'
import {COLORS} from '../constants'
import {NetworkStats} from '../utils/networkStats'
import {Grid, KpiCard, KpiCardTop, KpiLabel, KpiValue} from './NetworkKpiCards.styled'

type KpiCardConfig = {
  label: {i18nKey: string; defaults: string}
  value: string
  icon: ComponentType<SvgIconProps>
  iconColor: string
  valueColor: string
}

type NetworkKpiCardsProps = {
  stats: NetworkStats
  currency: string
}

/**
 * Headline KPI cards summarising the whole offers network shown above the tree
 * (Network AUM, Total Investors, Sub-Agents).
 *
 * @param stats - Aggregated network figures produced by `aggregateNetworkStats`.
 * @param currency - ISO currency code used to format the Network AUM value.
 */
export const NetworkKpiCards = ({stats, currency}: NetworkKpiCardsProps) => {
  const cards: KpiCardConfig[] = [
    {
      label: messages.pammNetworkAum,
      value: getFormattedAmount({amount: stats.networkAum, currency}),
      icon: AccountBalanceWalletOutlined,
      iconColor: COLORS.brand,
      valueColor: COLORS.brand,
    },
    {
      label: messages.totalInvestors,
      value: String(stats.totalInvestors),
      icon: PeopleOutlined,
      iconColor: COLORS.foreground,
      valueColor: COLORS.foreground,
    },
    {
      label: messages.pammNetworkSubAgents,
      value: String(stats.subAgentCount),
      icon: LayersOutlined,
      iconColor: COLORS.foreground,
      valueColor: COLORS.foreground,
    },
  ]

  return (
    <Grid>
      {cards.map((card) => {
        const Icon = card.icon
        return (
          <KpiCard key={card.label.i18nKey}>
            <KpiCardTop>
              <KpiLabel>
                <Trans {...card.label} />
              </KpiLabel>
              <Icon style={{fontSize: 18, color: card.iconColor}} />
            </KpiCardTop>
            <KpiValue style={{color: card.valueColor}}>{card.value}</KpiValue>
          </KpiCard>
        )
      })}
    </Grid>
  )
}
